/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Refresh_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Refresh tag sets" |
*
* @param {Tags_Refresh_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_refresh_aria_label = /** @type {((inputs?: Tags_Refresh_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Refresh_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser les ensembles de balises")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag-Sets aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna i set di tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить наборы тегов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar conjuntos de etiquetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新标签集")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグセットを更新する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग सेट रीफ़्रेश करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar conjuntos de tags")
	return /** @type {LocalizedString} */ ("Refresh tag sets")
});